import styled from '@emotion/styled'
import {Bookmark, Comment, Delete, Edit, Keyboard} from '@mui/icons-material'
import React from 'react'
import {PALETTE} from '~/styles/paletteV3'

const Wrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  paddingLeft: 8,
  paddingRight: 8,
  width: '100%'
})

const ItemIcon = styled('div')({
  color: PALETTE.SLATE_600,
  height: 24,
  width: 24,
  margin: 8
})

const Label = styled('div')({
  color: PALETTE.SLATE_700,
  fontSize: 14,
  lineHeight: '32px'
})








const MenuItemWithIcon = (props) => {
  const {icon, label, dataCy} = props
  return (
    React.createElement(Wrapper, { 'data-cy': `${dataCy}`,}
      , React.createElement(ItemIcon, null
        , 
          {
            delete: React.createElement(Delete, null ),
            bookmark: React.createElement(Bookmark, null ),
            keyboard: React.createElement(Keyboard, null ),
            comment: React.createElement(Comment, null ),
            edit: React.createElement(Edit, null )
          }[icon]
        
      )
      , React.createElement(Label, null, label)
    )
  )
}

export default MenuItemWithIcon
